import { render, staticRenderFns } from "./position-add-or-update.vue?vue&type=template&id=252d9b38"
import script from "./position-add-or-update.vue?vue&type=script&lang=js"
export * from "./position-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./position-add-or-update.vue?vue&type=style&index=0&id=252d9b38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports